import { render, staticRenderFns } from "./ConcentrationChart.vue?vue&type=template&id=2a4d265c&scoped=true&"
import script from "./ConcentrationChart.vue?vue&type=script&lang=ts&"
export * from "./ConcentrationChart.vue?vue&type=script&lang=ts&"
import style0 from "./ConcentrationChart.vue?vue&type=style&index=0&id=2a4d265c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d265c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VSimpleTable,VTooltip})
